import type { BuildEventStructure, PropertyEventStructure } from "@/eventManager/events/types";

export const getDeleteVoteEventData = (
    UID: string,
    userToken: string,
    isOwner: boolean,
): BuildEventStructure[] => {
    return [
        {
            type: "build",
            action: "delete",
            entities: [
                {
                    entityType: "vote",
                    UID: UID,
                    token: userToken,
                    isOwner,
                },
            ],
        },
    ];
};

export const getRenameVoteEventData = (UID: string, name: string): PropertyEventStructure[] => {
    return [
        {
            type: "property",
            UID: UID,
            fixType: "text",
            entityType: "vote",
            state: {
                text: name,
            },
        },
    ];
};
